import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IoMdClose } from "react-icons/io";
import MainLayout from "../../Layout/mainLayout";
import { Link } from "react-router-dom";
import { formatKey } from "../../Utils/helpers";



const ViewPlan = ({ setShow }) => {
  const currentPlan = useSelector((state) => state.subscriptionView);

  return (
    <MainLayout>
      <div className="custom-popup">
        <div className="popup-header">
          <div className="top_bar">
            <h1>VIEW PLAN</h1>
            <Link to="/Plans">
              <button
                style={{
                  padding: "15px 20px",
                  background: "#172358",
                  color: "white",
                  borderRadius: "25px",
                  fontSize: "15px",
                  cursor: "pointer",
                }}
              >
                View Plan List
              </button>
            </Link>
          </div>
        </div>
        <div className="popup-body">
   <div style={{ display: "flex", flexDirection: "column" }}>
  {currentPlan && (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
      }}
    >
      {Object.entries(currentPlan?.data?.data).map(([Key, val]) => (
        <ul
          key={Key}
          style={{
            flex: "1 1 45%", 
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}
        >
          <li>
            <strong>{formatKey(Key)}:</strong> {String(val)}
          </li>
        </ul>
      ))}
    </div>
  )}
</div>

        </div>
 
      </div>
    </MainLayout>
  );
};

export default ViewPlan;
